import SSView from 'core/src/views/base/ss-view';
import NotificationsCollection from 'core/src/collections/notifications';
import NotificationCollectionView from 'core/src/views/collection-views/notification-collection-view';
import InfiniteScrollerView from 'core/src/views/modules/infinite-scroller';
import ErrorTemplate from 'text!core/src/templates/notifications/_error.mustache';
import EmptyTemplate from 'text!core/src/templates/notifications/_empty.mustache';
import ClassActivityEmptyTemplate from 'text!core/src/templates/notifications/_class_activity_empty.mustache';

const UnifiedNotificationsModule = SSView.extend({

  notificationsContainerEl: null,

  disableFetch: false,
  autoloadBasedOnContainerHeight: false,
  completedNotificationInitialRequest: false,
  completedClassNotificationInitialRequest: false,

  emptyTemplate: EmptyTemplate,
  classActivityEmptyTemplate: ClassActivityEmptyTemplate,
  errorTemplate: ErrorTemplate,

  initialize: function(options) {
    _.extend(this, _.pick(options, ['notificationsContainerEl', 'notificationsListEl', 'classNotificationsContainerEl', 'classNotificationsListEl']));

    _.bindAll(this, 'onCollectionSuccess', 'onCollectionError', 'onFetchDeactivate');

    this.notificationCollection = new NotificationsCollection([], {
      success: this.onCollectionSuccess,
      error: this.onCollectionError,
      classActivityTab: false,
    });
    if (SS.serverBootstrap.userData.is_teacher) {
      this.classNotificationCollection = new NotificationsCollection([], {
        success: this.onCollectionSuccess,
        error: this.onCollectionError,
        classActivityTab: true,
      });
    }

    SSView.prototype.initialize.apply(this, arguments);
  },

  afterRender: function() {
    this.$notificationCountEl = $('.nav-menu-notifications-count');

    this.notificationCollectionView = new NotificationCollectionView({
      el: this.notificationsListEl,
      collection: this.notificationCollection,
    });

    if (SS.serverBootstrap.userData.is_teacher) {
      this.classNotificationCollectionView = new NotificationCollectionView({
        el: this.classNotificationsListEl,
        collection: this.classNotificationCollection,
      });
    }

    this.notificationCollectionView.infiniteScrollerView = new InfiniteScrollerView({
      container: this.notificationCollectionView.$el,
      viewport: this.notificationsContainerEl,
      scrollEl: this.notificationsContainerEl,
      collection: this.notificationCollection,
    });

    if (this.classNotificationsContainerEl) {
      this.classNotificationCollectionView.infiniteScrollerView = new InfiniteScrollerView({
        container: this.classNotificationCollectionView.$el,
        viewport: this.classNotificationsContainerEl,
        scrollEl: this.classNotificationsContainerEl,
        collection: this.classNotificationCollection,
      });
    }

    this.listenTo(this.notificationCollectionView.infiniteScrollerView, 'fetch:deactivate', this.onFetchDeactivate);

    if (SS.serverBootstrap.userData.is_teacher) {
      this.listenTo(this.classNotificationCollectionView.infiniteScrollerView, 'fetch:deactivate', this.onFetchDeactivate);
    }

    this.performInitialFetchIfNecessary();

    SSView.prototype.afterRender.apply(this, arguments);
  },

  onFetchDeactivate: function() {
    if (!this.disableFetch) {
      this.fetchIfNeeded(this.notificationCollectionView);
      if (SS.serverBootstrap.userData.is_teacher) {
        this.fetchIfNeeded(this.classNotificationCollectionView);
      }
    }
  },

  fetchIfNeeded: function(view) {
    const viewHeight = view.$el.innerHeight();
    const viewContainerHeight = view.$el.parent().innerHeight();
    const viewTotalHeight = view.$el.offset().top + viewHeight;
    const windowHeight = $(window).innerHeight();
    const loadBasedOnContainer = this.autoloadBasedOnContainerHeight && viewHeight < viewContainerHeight;
    const loadBasedOnVisibility = windowHeight - viewTotalHeight > 0 && this.isTabVisible(viewTotalHeight);
    if ( loadBasedOnContainer || loadBasedOnVisibility ) {
      view.infiniteScrollerView.fetch();
    }
  },

  isTabVisible: function(height) {
    return height != 0;
  },

  performInitialFetchIfNecessary: function() {
    if (!this.completedNotificationInitialRequest) {
      this.notificationCollectionView.infiniteScrollerView.fetch();
    }
    if (!this.completedClassNotificationInitialRequest && SS.serverBootstrap.userData.is_teacher) {
      this.classNotificationCollectionView.infiniteScrollerView.fetch();
    }
  },
  onCollectionSuccess: function(collection, response, options) {
    if (SS.serverBootstrap.userData.is_teacher) {
      this.appendEmptyTemplate(response.teacherNotifications, this.classNotificationCollectionView.$el,
        this.classActivityEmptyTemplate, !this.completedClassNotificationInitialRequest);
    }
    this.appendEmptyTemplate(response.notifications, this.notificationCollectionView.$el,
      this.emptyTemplate, !this.completedNotificationInitialRequest);
    this.handleFirstResponse(collection, response, options);
    this.completedNotificationInitialRequest = true;
    this.completedClassNotificationInitialRequest = true;
    collection.trigger('update', response, options);
  },
  onCollectionError: function(collection) {
    this.disableFetch = true;
    if (collection.classActivityTab) {
      this.completedClassNotificationInitialRequest = true;
      this.classNotificationCollectionView.$el.append(this.errorTemplate);
    } else {
      this.completedNotificationInitialRequest = true;
      this.notificationCollectionView.$el.append(this.errorTemplate);
    }
    collection.trigger('update:error');
  },
  handleFirstResponse: function() {
    // clear the notifications jewel
    const { title } = document;
    const titleCounter = title.match(/\([^)]*\)/g);

    this.$notificationCountEl.hide();
    document.title = titleCounter ? title.replace(titleCounter, '').trim() : title;
  },
  appendEmptyTemplate: function(collection, view, template, requestNotCompleted) {
    if (collection.length == 0 && requestNotCompleted) {
      view.append(template);
    }
  },
});

export default UnifiedNotificationsModule;

